import React from 'react';
import {
  IconCard as StyledIconCard,
  IconCardContent,
  IconCircle,
  IconImage,
  TextContainer,
  CountText,
  DescriptionText,
} from './styles';

interface IconCardProps {
  iconSrc: string;
  count: string | number;
  description: string;
  alt?: string;
}

const IconCard: React.FC<IconCardProps> = ({
  iconSrc,
  count,
  description,
  alt = `Icon representing ${description}`,
}) => {
  return (
    <StyledIconCard>
      <IconCardContent>
        <IconCircle>
          <IconImage src={iconSrc} alt={alt} />
        </IconCircle>
        <TextContainer>
          <CountText>{count}</CountText>
          <DescriptionText>{description}</DescriptionText>
        </TextContainer>
      </IconCardContent>
    </StyledIconCard>
  );
};

export default IconCard;
